import { HttpMethods, makeRequest } from '../helpers/http.helper';
import type {
  DriverRequestStatus,
  FleetDriverRequestsMonitorResponse,
  RecyclerOrdersMonitorResponse,
} from '../types/monitoring.type';

interface GenericResponse<T> {
  result: T;
}

export async function getRecyclerOrdersMonitor(
  organizationId: string,
  offset: number,
  limit: number,
): Promise<RecyclerOrdersMonitorResponse> {
  const response = (await makeRequest({
    url: `/dashboard/recycler/${organizationId}/pre-orders`,
    method: HttpMethods.GET,
    params: {
      start_date: '2000-01-01T00:00:00.000Z',
      end_date: '2100-01-01T00:00:00.000Z',
      offset,
      limit,
    },
  })) as GenericResponse<RecyclerOrdersMonitorResponse>;
  return response.result;
}

export async function getFleetDriverRequestsMonitor(
  organizationId: string,
  page: number,
  limit: number,
  status?: DriverRequestStatus,
): Promise<FleetDriverRequestsMonitorResponse> {
  const response = (await makeRequest({
    url: `/pickup_order/fleet/${organizationId}/assignments`,
    method: HttpMethods.GET,
    params: { page, limit, status },
  })) as GenericResponse<FleetDriverRequestsMonitorResponse>;
  return response.result;
}
